import React, { useState, useEffect } from 'react'
import { Link, NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Index from '../../Assets/Images/Index';
import { loginUrl } from '../../Container/App';
import { signUpUrl } from '../../Container/App';
import { useMediaQuery } from "@uidotdev/usehooks";

import './Header.css'
import { faUser, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion, faDotCircle, faHouse, faUserAlt } from '@fortawesome/free-regular-svg-icons';

export default function Header() {
    const location = useLocation();
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const [width, setWidth] = useState(window.innerWidth);
    const [nav, setNav] = useState([
        {
            type: "nav", name: "Sell", link: "/sell",
            // submenu: [{ name: "Sell on Facebook", link: "/sell/facebook", }, { name: "Sell on Instagram", link: "/sell/instagram", }], 
            pos: "left", dropdown: false, nav: true
        },
        // { type: "nav", name: "Market", link: "/market", pos: "left", dropdown: false, },
        { type: "nav", name: "Manage", link: "/manage", pos: "left", dropdown: false, nav: true },
        // { type: "nav", name: "Learn", link: "/learn", pos: "right", dropdown: false, },
        { type: "anchor", name: "Support", link: "https://support.shopyxa.com/en/", pos: "right", dropdown: false, nav: false },
        { type: "nav", name: "Pricing", link: "/pricing", pos: "right", dropdown: false, nav: true },
        { type: "anchor", name: "Login", link: loginUrl, pos: "right", dropdown: false, nav: false },
    ])
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const toggleDropdorn = (i) => {
        let updatedMenu = []
        nav.map((data, index) => {
            if (i == index) {
                updatedMenu.push({ ...data, 'dropdown': !data.dropdown })
            } else {
                updatedMenu.push({ ...data, 'dropdown': false })
            }
        })
        setNav(updatedMenu)
    }
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [width]);


    const togglerClick = () => {
        if (width < 992) {
            document.getElementById("navbarToggle").click();
        }
    }

    const navToggle = () => {
        document.body.classList.toggle('open-nav');
    }

    const handlescroll = () => {

    }

    useEffect(() => {
        if (location.pathname === "/") {
            document.body.classList.add('home-page');
        } else {
            document.body.classList.remove('home-page');
        }
    }, [location.pathname]);

    return (
        <header id="header" className={`${isScrolled ? "header scrolled" : "header"}`}>
            <div className="announcementBar">
                <NavLink to="/pricing"><strong>Limited time offer:</strong> Get 50% off on all plans.</NavLink>
            </div>
            <div className="container">
                <div className="headerInner">
                    <div className="logo">
                        <Link to="/">
                            <img src={prefersDarkMode ? Index.logoWhite : Index.logo} alt="" width="173" />
                        </Link>
                    </div>
                    <div className="navigation">
                        <nav id="navbar">
                            <ul>
                                {nav.map((data, index) => {
                                    return (
                                        <li key={index}>
                                            {data.nav ?
                                                <NavLink to={data.link}>{data.name}</NavLink>
                                                :
                                                <a href={data.link}>{data.name}</a>
                                            }
                                        </li>
                                    )
                                })}
                            </ul>
                        </nav>
                        <button type="button" className="closeButton" onClick={navToggle}>
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>
                    <div className="headButton">
                        <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                    </div>
                </div>
            </div>
            <div className="mobile-bottom-nav show">
                {/* <div className="nav-inner single">
                    <div className="search"><img src="images/icons/search-icon.svg" alt="" /></div>
                </div> */}
                <div className="nav-inner multiple">
                    <div className="nav-item active">
                        <NavLink to="/">
                            <span className="icon">
                                <FontAwesomeIcon icon={faHouse} />
                            </span>
                        </NavLink>
                    </div>
                    <div className="nav-item">
                        <a href={loginUrl}>
                            <span className="icon">
                                <FontAwesomeIcon icon={faUserAlt} />
                            </span>
                        </a>
                    </div>
                    <div className="nav-item">
                        <a href='https://support.shopyxa.com/en/' target='_blank' rel="noreferrer">
                            <span className="icon">
                                <FontAwesomeIcon icon={faCircleQuestion} />
                            </span>
                        </a>
                    </div>
                    <div className="nav-item">
                        <div className="menuButton" onClick={navToggle}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div className="nav-inner single">

                </div>
            </div>
        </header>
    )
}
